import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import { useCart } from "../contexts/CartContext";
import api from "../api/api";

const BACKEND_URL = "https://imagensdaface.com.br";

export default function Checkout() {
  const { items, total, clearCart } = useCart();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [pixData, setPixData] = useState(null);
  const [boletoData, setBoletoData] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("pix"); 
  const [userData, setUserData] = useState(null);
  // Dentro do componente Checkout...
    const [showCpfModal, setShowCpfModal] = useState(false);
    const [cpfValue, setCpfValue] = useState("");
    const [updatingCpf, setUpdatingCpf] = useState(false);
  
  // --- NOVOS ESTADOS PARA O FRETE ---
  const [freteOptions, setFreteOptions] = useState([]);
  const [selectedFrete, setSelectedFrete] = useState(null);
  const [calculandoFrete, setCalculandoFrete] = useState(false);

  const [feedbackModal, setFeedbackModal] = useState({ show: false, title: "", message: "", type: "" });
  const [addressData, setAddressData] = useState({
    cep: "", address: "", number: "", complement: "", neighborhood: "", city: "", state: ""
  });

  const pollingTimer = useRef(null);

  useEffect(() => {
    fetchUser();
    return () => { if (pollingTimer.current) clearInterval(pollingTimer.current); };
  }, []);

  // 1. Busca usuário e já dispara o cálculo de frete se houver CEP
  const fetchUser = async () => {
    try {
      const response = await api.get("/users/me");
      setUserData(response.data);
      const addr = {
        cep: response.data.cep || "",
        address: response.data.address || "",
        number: response.data.number || "",
        complement: response.data.complement || "",
        neighborhood: response.data.neighborhood || "",
        city: response.data.city || "",
        state: response.data.state || ""
      };
      setAddressData(addr);

      // Se o usuário já tem CEP, calcula o frete automaticamente
      if (addr.cep && addr.cep.length >= 8) {
        calcularFreteAutomatico(addr.cep);
      }
    } catch (err) { console.error("Erro ao buscar usuário", err); }
  };

  // 2. Função de cálculo vinculada ao seu novo Backend Regional
  const calcularFreteAutomatico = async (cepDestino) => {
    if (items.length === 0) return;
    setCalculandoFrete(true);
    try {
      const res = await api.post("/frete/calcular", {
        cepDestino: cepDestino,
        weight: items[0].weight || "0.500" // Pega o peso do primeiro item
      });
      setFreteOptions(res.data);
      // Seleciona o primeiro (geralmente PAC) por padrão
      if (res.data.length > 0) setSelectedFrete(res.data[0]);
    } catch (err) {
      console.error("Erro frete checkout:", err);
    } finally { setCalculandoFrete(false); }
  };

  // 3. Valor Final (Soma Itens + Frete)
  const totalComFrete = total + (selectedFrete ? parseFloat(selectedFrete.Valor.replace(',', '.')) : 0);

  const handlePayment = async () => {
    if (items.length === 0) return;

    // 1. Validação de Frete
    if (!selectedFrete) {
      showFeedback("Frete Necessário", "Por favor, selecione uma opção de entrega.", "error");
      return;
    }

    // 🚩 2. Validação de CPF (Bloqueio se estiver vazio/null)
    const userCpf = userData?.cpf;
    if (!userCpf || userCpf === "" || userCpf === "null") {
      setShowCpfModal(true);
      return;
    }
    
    setLoading(true);
    try {
      const itemId = items[0].id;
      const payload = { 
        courseId: itemId, 
        freteValor: selectedFrete.Valor,
        freteTipo: selectedFrete.Codigo === '04014' ? 'SEDEX' : 'PAC'
      };

      if (paymentMethod === "pix") {
        const response = await api.post("/payments/pix", payload);
        setPixData(response.data);
        startPolling(response.data.txid);
      } 
      else if (paymentMethod === "boleto") {
        const response = await api.post("/payments/boleto", payload);
        const pdfLink = response.data.data?.pdf?.charge || response.data.data?.link;
        setBoletoData({ ...response.data.data, pdfUrl: pdfLink });
        clearCart(); 
        showFeedback("Boleto Gerado", "Aguardando compensação bancária.", "success");
      }
    } catch (error) {
      const msg = error.response?.data?.message || "Erro ao processar pagamento.";
      showFeedback("Erro", msg, "error");
    } finally { setLoading(false); }
  };
  
  
  
  const handleSaveCpf = async () => {
    if (cpfValue.length < 11) {
        toast.error("CPF inválido"); // ou use seu feedbackModal
        return;
    }
    
    setUpdatingCpf(true);
    try {
        await api.put("/users/profile", { cpf: cpfValue }); // Ajuste a rota conforme seu backend
        
        // Atualiza o userData local para que o handlePayment passe na próxima vez
        setUserData({ ...userData, cpf: cpfValue });
        setShowCpfModal(false);
        showFeedback("CPF Atualizado", "Agora você pode concluir sua compra.", "success");
    } catch (err) {
        showFeedback("Erro", "Não foi possível salvar seu CPF.", "error");
    } finally {
        setUpdatingCpf(false);
    }
};



  // Polling e Feedback permanecem iguais...
  const startPolling = (txid) => {
    if (pollingTimer.current) clearInterval(pollingTimer.current);
    pollingTimer.current = setInterval(async () => {
      try {
        const res = await api.get(`/payments/status/${txid}`);
        if (res.data.status === "PAID") {
          clearInterval(pollingTimer.current);
          setPixData(null); clearCart();
          showFeedback("Sucesso!", "Pagamento confirmado!", "success");
          setTimeout(() => { navigate("/dashboard"); }, 3000);
        }
      } catch (err) { }
    }, 3000);
  };

  const showFeedback = (title, message, type) => setFeedbackModal({ show: true, title, message, type });

  return (
    <AppLayout>
      <div className="container mx-auto px-6 py-10 max-w-5xl">
        <h1 className="text-3xl font-black mb-8 text-slate-800 tracking-tighter italic">Finalizar Compra</h1>

        {items.length === 0 && !boletoData && !pixData ? (
          <div className="text-center py-20 bg-white rounded-[32px] shadow-sm border border-slate-100 italic">
            <p className="text-slate-400 mb-6 text-lg">Seu carrinho está vazio.</p>
            <button onClick={() => navigate("/")} className="bg-slate-900 text-white px-8 py-3 rounded-full font-bold">Voltar à Loja</button>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-8">
            <div className="md:col-span-2 space-y-6">
              
              {/* LISTA DE PRODUTOS */}
              <div className="space-y-3">
                {items.map((item) => (
                  <div key={item.id} className="bg-white rounded-2xl p-4 flex items-center gap-4 border border-slate-100 shadow-sm">
                    <img src={item.image_url || `${BACKEND_URL}${item.cover_image_url}`} className="w-20 h-20 object-cover rounded-xl border" alt={item.name} />
                    <div className="flex-1">
                      <h3 className="font-bold text-slate-800 text-sm uppercase">{item.title || item.name}</h3>
                      <p className="text-emerald-600 font-black">R$ {Number(item.price).toFixed(2)}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* ENDEREÇO E FRETE */}
              <div className="bg-white rounded-[32px] p-8 shadow-sm border border-slate-100">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="font-bold text-lg text-slate-800">Entrega:</h2>
                    <span className="text-[10px] bg-slate-100 px-2 py-1 rounded font-bold text-slate-500">CEP: {addressData.cep}</span>
                </div>
                
                {calculandoFrete ? (
                    <div className="animate-pulse flex space-x-4">
                        <div className="flex-1 space-y-4 py-1">
                            <div className="h-4 bg-slate-200 rounded w-3/4"></div>
                            <div className="h-10 bg-slate-100 rounded"></div>
                        </div>
                    </div>
                ) : (
                    <div className="space-y-3">
                        {freteOptions.length > 0 ? (
                            freteOptions.map((opt, idx) => (
                                <button 
                                    key={idx}
                                    onClick={() => setSelectedFrete(opt)}
                                    className={`w-full flex justify-between items-center p-4 rounded-2xl border-2 transition-all ${selectedFrete?.Codigo === opt.Codigo ? 'border-emerald-500 bg-emerald-50' : 'border-slate-100'}`}
                                >
                                    <div className="text-left">
                                        <p className="text-xs font-black text-slate-700 uppercase">
                                            {opt.Codigo === '04014' ? '🚀 Sedex' : '📦 PAC'}
                                        </p>
                                        <p className="text-[10px] text-slate-400">Entrega em {opt.PrazoEntrega} dias úteis</p>
                                    </div>
                                    <span className="font-black text-emerald-600">R$ {opt.Valor}</span>
                                </button>
                            ))
                        ) : (
                            <p className="text-red-500 text-xs font-bold">⚠️ Frete não cadastrado para seu CEP. Verifique seu perfil.</p>
                        )}
                    </div>
                )}
              </div>

              {/* MÉTODO PAGAMENTO */}
              <div className="bg-white rounded-[32px] p-8 shadow-sm border border-slate-100">
                <h2 className="font-bold text-lg mb-6 text-slate-800">Pagamento:</h2>
                <div className="grid grid-cols-2 gap-4">
                  <button onClick={() => setPaymentMethod('pix')} className={`p-4 rounded-2xl border-2 flex flex-col items-center gap-1 ${paymentMethod === 'pix' ? 'border-indigo-600 bg-indigo-50 text-indigo-700' : 'border-slate-50 text-slate-400'}`}>
                    <span className="text-2xl">💠</span><span className="text-[10px] font-black uppercase">PIX</span>
                  </button>
                  <button onClick={() => setPaymentMethod('boleto')} className={`p-4 rounded-2xl border-2 flex flex-col items-center gap-1 ${paymentMethod === 'boleto' ? 'border-indigo-600 bg-indigo-50 text-indigo-700' : 'border-slate-50 text-slate-400'}`}>
                    <span className="text-2xl">📄</span><span className="text-[10px] font-black uppercase">BOLETO</span>
                  </button>
                </div>
              </div>
            </div>

            {/* RESUMO FIXO */}
            <div className="bg-slate-900 p-8 rounded-[40px] text-white h-fit shadow-2xl sticky top-20 border border-white/10">
              <h2 className="text-xl font-bold mb-4">Resumo do Pedido</h2>
              <div className="space-y-3 mb-6 border-b border-white/10 pb-6">
                <div className="flex justify-between text-sm text-slate-400">
                    <span>Subtotal:</span>
                    <span>R$ {total.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-sm text-slate-400">
                    <span>Frete ({selectedFrete?.Codigo === '04014' ? 'Sedex' : 'PAC'}):</span>
                    <span>R$ {selectedFrete ? selectedFrete.Valor : '0,00'}</span>
                </div>
              </div>
              <p className="text-[10px] uppercase font-bold text-slate-500 mb-1">Total a Pagar:</p>
              <p className="text-5xl font-black mb-8 text-emerald-400">R$ {totalComFrete.toFixed(2)}</p>
              
              <button onClick={handlePayment} disabled={loading || items.length === 0 || !selectedFrete} className="w-full py-5 bg-emerald-500 rounded-2xl font-black text-slate-950 shadow-xl shadow-emerald-500/20 transition-all hover:scale-[1.02] active:scale-95 disabled:bg-slate-800 disabled:text-slate-600">
                {loading ? "Processando..." : "Confirmar Compra"}
              </button>
            </div>
          </div>
        )}

        {/* MODAL PIX */}
        {pixData && (
          <div className="fixed inset-0 z-[2000] bg-slate-950/95 backdrop-blur-md flex items-center justify-center p-4">
            <div className="bg-white rounded-[40px] w-full max-w-lg flex flex-col overflow-hidden shadow-2xl border border-white/20">
              <div className="p-8 border-b flex justify-between items-center bg-slate-50">
                <div>
                  <h2 className="text-2xl font-black text-slate-800">Pagamento via Pix</h2>
                  <p className="text-sm text-slate-500">Escaneie o código ou use Copia e Cola</p>
                </div>
                <button onClick={() => setPixData(null)} className="w-10 h-10 rounded-full bg-slate-200 text-slate-600 font-bold hover:bg-red-500 hover:text-white transition-all">✕</button>
              </div>
              
              <div className="p-10 flex flex-col items-center bg-white">
                <div className="p-4 bg-slate-50 rounded-3xl mb-6 border-2 border-dashed border-slate-200">
                  <img src={pixData.qrcode_image} alt="QR Code Pix" className="w-64 h-64 mx-auto" />
                </div>
                
                <div className="w-full space-y-4">
                   <div className="p-4 bg-indigo-50 rounded-2xl border border-indigo-100">
                      <p className="text-[10px] uppercase font-black text-indigo-400 mb-1 text-center tracking-widest">Código Pix (Copia e Cola)</p>
                      <p className="text-xs text-slate-600 break-all text-center font-mono bg-white p-3 rounded-xl border border-indigo-100">{pixData.qrcode_text}</p>
                   </div>
                   
                   <button 
                     onClick={() => { navigator.clipboard.writeText(pixData.qrcode_text); showFeedback("Copiado!", "Código Pix pronto para colar no seu banco.", "success") }}
                     className="w-full py-4 bg-indigo-600 text-white rounded-2xl font-black shadow-lg shadow-indigo-200 hover:bg-indigo-700 transition-all active:scale-95"
                   >
                     Copiar Código Pix
                   </button>
                </div>
              </div>

              <div className="p-6 bg-slate-50 border-t flex items-center justify-center gap-3">
                <div className="w-2 h-2 bg-emerald-500 rounded-full animate-ping"></div>
                <p className="text-xs font-bold text-slate-500">Aguardando confirmação em tempo real...</p>
              </div>
            </div>
          </div>
        )}
        
        {/* MODAL DE CADASTRO DE CPF */}
        {showCpfModal && (
          <div className="fixed inset-0 z-[4000] bg-slate-950/90 backdrop-blur-md flex items-center justify-center p-4">
            <div className="bg-white rounded-[40px] p-10 max-w-md w-full shadow-2xl border border-white/20">
              <div className="text-center mb-8">
                <div className="w-20 h-20 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4 text-3xl">🆔</div>
                <h3 className="text-2xl font-black text-slate-800">CPF Obrigatório</h3>
                <p className="text-slate-500 text-sm mt-2">Para gerar seu pagamento com segurança, precisamos do seu CPF vinculado à conta.</p>
              </div>
        
              <div className="space-y-4">
                <div>
                  <label className="text-[10px] font-black uppercase text-slate-400 ml-2">Seu CPF (Somente números)</label>
                  <input 
                    type="text" 
                    maxLength="11"
                    value={cpfValue}
                    onChange={(e) => setCpfValue(e.target.value.replace(/\D/g, ''))}
                    placeholder="000.000.000-00"
                    className="w-full p-5 bg-slate-50 border-2 border-slate-100 rounded-2xl focus:border-indigo-500 outline-none font-bold text-slate-700 transition-all"
                  />
                </div>
        
                <button 
                  onClick={handleSaveCpf}
                  disabled={updatingCpf || cpfValue.length < 11}
                  className="w-full py-5 bg-indigo-600 text-white rounded-2xl font-black shadow-xl shadow-indigo-200 hover:bg-indigo-700 transition-all disabled:bg-slate-200 disabled:shadow-none"
                >
                  {updatingCpf ? "Salvando..." : "Salvar e Continuar"}
                </button>
                
                <button 
                  onClick={() => setShowCpfModal(false)} 
                  className="w-full py-2 text-slate-400 text-xs font-bold hover:text-red-500 transition-all"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* MODAL BOLETO */}
        {boletoData && (
          <div className="fixed inset-0 z-[2000] bg-slate-950/90 backdrop-blur-md flex items-center justify-center p-4">
            <div className="bg-white rounded-[40px] w-full max-w-4xl h-[85vh] flex flex-col overflow-hidden shadow-2xl">
              <div className="p-8 border-b flex justify-between items-center bg-slate-50">
                <h2 className="text-2xl font-black text-slate-800">Boleto Gerado com Sucesso!</h2>
                <button onClick={() => setBoletoData(null)} className="w-10 h-10 rounded-full bg-slate-200 text-slate-600 font-bold hover:bg-red-500 hover:text-white transition-all">✕</button>
              </div>
              <div className="flex-1">
                <iframe src={`${boletoData.pdfUrl}#toolbar=0`} className="w-full h-full border-none" title="Boleto" />
              </div>
              <div className="p-8 border-t flex gap-4 justify-end bg-white">
                 <button onClick={() => { navigator.clipboard.writeText(boletoData.barcode); showFeedback("Copiado!", "Código de barras copiado.", "success") }} className="px-6 py-3 bg-slate-100 text-slate-700 rounded-2xl font-bold">Copiar Linha Digitável</button>
                 <a href={boletoData.pdfUrl} target="_blank" rel="noreferrer" className="px-8 py-3 bg-indigo-600 text-white rounded-2xl font-bold shadow-lg">Baixar PDF</a>
              </div>
            </div>
          </div>
        )}

        {/* MODAL FEEDBACK */}
        {feedbackModal.show && (
          <div className="fixed inset-0 z-[3000] bg-slate-950/80 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white rounded-[40px] p-10 max-w-sm w-full text-center shadow-2xl border border-slate-100">
              <div className={`text-7xl mb-6 ${feedbackModal.type === 'success' ? 'text-emerald-500' : 'text-red-500'}`}>
                {feedbackModal.type === 'success' ? '✓' : '✕'}
              </div>
              <h3 className="text-2xl font-black mb-3 text-slate-800">{feedbackModal.title}</h3>
              <p className="text-slate-500 mb-8 leading-relaxed">{feedbackModal.message}</p>
              <button onClick={() => setFeedbackModal({...feedbackModal, show: false})} className="w-full py-4 bg-slate-900 text-white rounded-2xl font-black hover:bg-slate-800 transition-all">Entendido</button>
            </div>
          </div>
        )}

      </div>
    </AppLayout>
  );
}